'use client'

import dynamic from 'next/dynamic'
import * as React from 'react'

const HoverActionsLazy = dynamic(() => import('./hover-actions-impl').then(m => m.HoverActions), {
  ssr: false,
})

export const HoverActions = (props: React.ComponentProps<typeof HoverActionsLazy>) => {
  return <HoverActionsLazy {...props} />
}
